module.exports = __webpack_public_path__ + "img/tool-graffiti.9ee0ddab.svg";